import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="py-4 border-t border-[#2a2219]" style={{ backgroundColor: '#1a1510' }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-5 text-xs text-gray-400">
          <a href="tel:+491621608568" className="flex items-center gap-2 hover:text-amber-400 transition-colors" data-testid="footer-phone">
            <Phone className="h-3 w-3 text-amber-500" />
            <span>+49 162 1608568</span>
          </a>
          <span className="hidden md:inline text-gray-600">|</span>
          <a href="mailto:info@trockenbau-be.de" className="flex items-center gap-2 hover:text-amber-400 transition-colors" data-testid="footer-email">
            <Mail className="h-3 w-3 text-amber-500" />
            <span>info@trockenbau-be.de</span>
          </a>
          <span className="hidden md:inline text-gray-600">|</span>
          <Link to="/datenschutz" className="hover:text-amber-400 transition-colors" data-testid="footer-datenschutz">
            Datenschutz
          </Link>
          <span className="hidden md:inline text-gray-600">|</span>
          <a href="https://www.marc.de" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-amber-400 transition-colors">
            Webdesign by marc.de
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
